import { useEffect, type RefObject } from 'react'

/**
 * Grows a textarea to fit its content.
 *
 * The original bound a single delegated `input` listener on `document` from
 * inside GiveawayNew's `created()` (never removed) and additionally re-measured
 * every textarea on the page after each wizard step via a `setTimeout(..., 0.001)`.
 * Scoped to the element that actually needs it.
 */
export function useAutoResize(ref: RefObject<HTMLTextAreaElement | null>, value: string): void {
  useEffect(() => {
    const element = ref.current
    if (!element) return
    element.style.height = 'inherit'
    element.style.height = `${element.scrollHeight}px`
  }, [ref, value])
}
